export const friendsTranslations = {
  ru: {
    title: "Мои друзья",
    stats: "У вас {total} друзей, из них {online} сейчас в сети.",
    searchPlaceholder: "Поиск по никнейму...",
    sortOnline: "По онлайну",
    loadingFriends: "Загрузка списка друзей...",
    loginRequired: "Войдите в аккаунт, чтобы просматривать друзей.",
    noFriendsTitle: "У вас пока нет друзей",
    noFriendsDesc: "Перейдите в профиль игрока и нажмите «Подписаться», чтобы добавить его.",
    searchEmpty: "По запросу «{query}» никого не найдено.",
    inGame: "В игре",
    removeTitle: "Удалить из друзей",
    removeBtn: "Удалить",
    confirmRemove: "Удалить {nickname} из друзей?"
  },
  en: {
    title: "My Friends",
    stats: "You have {total} friends, {online} of them are online.",
    searchPlaceholder: "Search by nickname...",
    sortOnline: "Online first",
    loadingFriends: "Loading friends list...",
    loginRequired: "Log in to view your friends.",
    noFriendsTitle: "You don't have any friends yet",
    noFriendsDesc: "Go to a player's profile and click 'Follow' to add them.",
    searchEmpty: "No one found for «{query}».",
    inGame: "In game",
    removeTitle: "Remove from friends",
    removeBtn: "Remove",
    confirmRemove: "Remove {nickname} from friends?"
  }
};